import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { Link, Redirect, useParams } from "react-router-dom"
import "../../../ShippingData.css";
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Host } from '../../../App';
import { loadCustomers } from '../../../Dashboard';

import App from '../../../App';
import His_Inventory from './Inventory';
import Flex_Inventory from './New_flex_Inv';
import Rigid_Inventory from './New_rigid_Inv';
import InventoryReportTable from './InventoryReportTable';
import Scrap from './Scrap';
import Wood_Inventory from './New_woodshop_Inv';
import Metal_Inventory from './New_Metal_Inv';
import SlapFoam_Inventory from './New_SlapFoam_Inv';

function Parts_Inventory() {
  // For Print

  //search for data
  const [PartNo, setPartno] = useState({});
  const [PartDesc, setPartDesc] = useState({});
  const [InternalPart, setInternalPart] = useState({});
  const [Customers, setCustomers] = useState({});
  const [Category, setCategory] = useState({});
  const [Type, setType] = useState({});
  const [flex_inv, setflex_inv] = useState(false);
  const [scrap_inv, setscrap_inv] = useState(false);
  const [AllColumns, setAllColumns] = useState(false);
  const [Inventory, setInventory] = useState(true);
  const [rigid_inv, setrigid_inv] = useState(false);
  const [wood_inv, setwood_inv] = useState(false);
  const [metal_inv, setmetal_inv] = useState(false);
  const [slabfoam_inv, setslabfoam_inv] = useState(false);
  const [pivot, setpivot] = useState(false);
  const [del, setdel] = useState(0);
  const [partDataset, setpartDataset] = useState([]);
  const [Part_No, setPartNo] = useState("");
  const [Part_Description, setPart_description] = useState("");
  const [Customer, setCustomer] = useState("");
  const [CATEGORY, setcategory] = useState("");
  const [Unit_Price, setunitprice] = useState("");
  const [CURRENCY, setcurrency] = useState("");
  const [SIZE, setsize] = useState("");
  const [BASE_STYLE_TUHOY, setbasestyletoughy] = useState("");
  const [MOLDING, setMoulding] = useState("");
  const [WOODSHOP, setWoodshop] = useState("");
  const [UPHOLSTERY, setUpholstery] = useState("");
  const [BUY_AND_SELL, setbuyandsell] = useState("");
  var userName = (window.localStorage.getItem("Name").replace(/[{""}]/g, ""));
  const [rank, setrank] = useState(false);
  const [Area, setArea] = useState("Inventory History");
  var token = (window.localStorage.getItem("acessToken"));

  // section for just temporary inventory
  var [Date1, setDate1] = useState(new Date());
  const [Postartdate1, setPoStartdate1] = useState();
  const [Poenddate1, setPoenddate1] = useState('2026-12-31');
  const [customer, setCustomer1] = useState({});
  const [Partdesc, setPartdesc] = useState({});
  const [postList, setPostList] = useState([]);
  const queryParams = {
    enddate: Poenddate1,
    startdate: Postartdate1,
    Customer: customer,
    Part_Desc: Partdesc,
    token: token,
  };
  useEffect(() => {
    Axios.get(`https://${Host}/latestdate/Inventory`, { params: queryParams })
      .then((res) => {
        console.log("Latest inventory date response:", res.data[0]?.latest);
        const iso = res.data[0]?.latest;       // "2025-07-27T06:00:00.000Z"
        if (iso) {
          setPoStartdate1(iso.slice(0, 10));    // "2025-07-27"
        }
      })
      .catch((error) => {
        console.error("Error fetching production schedule:", error);
      });
  }, []);
  useEffect(() => {
    console.log("Fetching production schedule with params:", queryParams);
    Axios.get(`https://${Host}/realapi/Production/Temp_Inventory_All`, { params: queryParams })
      .then((response) => {
        setPostList(response.data[2]);
        console.log(response.data[2]);
      })
      .catch((error) => {
        console.error("Error fetching production schedule:", error);
      });
  }, [Postartdate1, Poenddate1, customer, Partdesc]);

  var Ranked = (window.localStorage.getItem("Rank"));
  var Stage = (window.localStorage.getItem("Stage"));



  const [data, setData] = useState([
    { Part_No: "", Part_internalNo: "", Part_Description: "", Customer: "", Type: "" },
  ]);
  const [filter, setFilter] = useState(
    [{ Emp_ID: "", EmployeeName: "", ContactNumber: "", Department: "", Source: "", Position: "", Status: "", token: token },
    ]);
  const updateFilter = (e, key) => {
    const { value } = e.target;
    setFilter(prevData => {
      const newData = [...prevData];
      newData[0][key] = value;
      return newData;
    });
  };

  const handleClick = (type) => {
    if (type === 'flex') {
      if (!flex_inv) {
        // Switch to Flex Inventory
        setflex_inv(true);
        setrigid_inv(false);
        setInventory(false);
        setscrap_inv(false);
        setpivot(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("New Flex Inventory");
      } else {
        // Flex button says "Inventory History" now
        setInventory(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setrigid_inv(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("Inventory History");
      }
    } else if (type === 'rigid') {
      if (!rigid_inv) {
        // Switch to Rigid Inventory
        setrigid_inv(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setInventory(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("New Rigid Inventory");
      } else {
        // Rigid button says "Inventory History" now
        setInventory(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setrigid_inv(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("Inventory History");
      }
    } else if (type === 'metal') {
      if (!metal_inv) {
        // Switch to Metal Inventory
        setmetal_inv(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setInventory(false);
        setwood_inv(false);
        setrigid_inv(false);
        setslabfoam_inv(false);
        setArea("New Metal Inventory");
      } else {
        // Rigid button says "Inventory History" now
        setInventory(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setrigid_inv(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("Inventory History");
      }
    } else if (type === 'slabfoam') {
      if (!slabfoam_inv) {
        // Switch to Slap Foam Inventory
        setslabfoam_inv(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setInventory(false);
        setwood_inv(false);
        setrigid_inv(false);
        setmetal_inv(false);
        setArea("New Slap Foam Inventory");
      } else {
        // Slap Foam button says "Inventory History" now
        setInventory(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setrigid_inv(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("Inventory History");
      }
    } else if (type === 'wood') {
      if (!wood_inv) {
        // Switch to Wood Inventory
        setrigid_inv(false);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setInventory(false);
        setwood_inv(true);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("New Wood Inventory");
      } else {
        // Rigid button says "Inventory History" now
        setInventory(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setrigid_inv(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("Inventory History");
      }
    } else if (type === 'pivot') {
      if (!pivot) {
        // Switch to Rigid Inventory
        setrigid_inv(false);
        setflex_inv(false);
        setpivot(true);
        setscrap_inv(false);
        setInventory(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("Inventory Pivot");
      } else {
        // Rigid button says "Inventory History" now
        setInventory(true);
        setflex_inv(false);
        setpivot(false);
        setscrap_inv(false);
        setrigid_inv(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea("Inventory History");
      }
    } else if (type === 'scrap') {
      /* NEW – Scrap toggle */
      if (!scrap_inv) {
        // switch to Scrap Inventory
        setscrap_inv(true);
        setrigid_inv(false);
        setflex_inv(false);
        setpivot(false);
        setInventory(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea('Scrap');
      } else {
        // Scrap button now shows "Inventory History"
        setInventory(true);
        setscrap_inv(false);
        setrigid_inv(false);
        setflex_inv(false);
        setpivot(false);
        setwood_inv(false);
        setmetal_inv(false);
        setslabfoam_inv(false);
        setArea('Inventory History');
      }
    }
  };

  const handleDoubleClick = () => {
    setInventory(true);
  };
  const partfilters = {
    PartNo: PartNo,
    PartDesc: PartDesc,
    Customers: Customers,
    Category: Category,
    token: token,
    InternalPart: InternalPart,
    Type: Type
  }
  useEffect(() => {
    if (Ranked === '"Admin"' && Stage === '"2"') {
      setrank(true);
    }
  }, [Ranked]);
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/Inventory/partdataset`, { params: partfilters }).then((data) => {
      setpartDataset(data.data)
    });
  }, [PartNo, PartDesc, Customers, Category, del, InternalPart, Type])

  const submitValue = (e, index) => {
    const newData = [...data];
    newData[index].Part_No = e.target.value;
    if (partDataset.find((x) => x.Part_No === e.target.value)) {
      newData[index].Customer = (partDataset.find((x) => x.Part_No === e.target.value).Customer);

      newData[index].Part_Description = partDataset.find((x) => x.Part_No === e.target.value).Part_Description;
      setData(newData);
    }
  }
  //

  const [changedLine, setChangedLine] = useState(new Set());
  const handleInputChange = (e, index, key) => {
    const { value } = e.target;
    updateDatas(index, key, value);
  };

  const updateDatas = (index, key, value) => {
    setpartDataset(prevData => {
      const newData = [...prevData];
      newData[index][key] = value;
      return newData;
    });
    // Add the index of the changed row to the set of changed rows
    setChangedLine(prevRows => new Set(prevRows).add(index));
  };

  const submitpart = () => {
    console.log(data);
    Axios.post(`https://` + Host + `/api/add/InternalpartDataset`, { Data: data, token: token }).then((response) => {
      console.log(response.data);
      if (response.status === 200) {
        setData([{ Part_No: "", Part_internalNo: "", Part_Description: "", Customer: "", Type: "" },]);
        window.alert(response.data.message);
      }


      setflex_inv(false);
      setdel(del + 1);
    })
      .catch(function (error) {
        console.log(error.response);
      });
  }

  const Update = () => {
    const changedData_ = [...changedLine].map(index => {
      return partDataset[index];

    });
    console.log(changedData_);

    Axios.post(`https://` + Host + `/api/internalpartDataset/Update`, { changedData: JSON.stringify(changedData_), token: token }).then((response) => {
      console.log(response.data);
      if (response.status === 200) {
        window.alert(response.data.message);
      }
      setflex_inv(false);
      setdel(del + 1);
    })
      .catch(function (error) {
        console.log(error.response);
      });

  };


  const submitpartdatasetdata = () => {
    console.log(Part_No + Part_Description + Customer + CATEGORY + Unit_Price + CURRENCY + SIZE + BASE_STYLE_TUHOY + MOLDING + WOODSHOP + UPHOLSTERY + BUY_AND_SELL);
    Axios.post(`https://` + Host + `/api/submitpartdatasetdata`, {
      Part_No: Part_No,
      Part_Description: Part_Description,
      Customer: Customer,
      CATEGORY: CATEGORY,
      Unit_Price: Unit_Price,
      CURRENCY: CURRENCY,
      SIZE: SIZE,
      BASE_STYLE_TUHOY: BASE_STYLE_TUHOY,
      MOLDING: MOLDING,
      WOODSHOP: WOODSHOP,
      UPHOLSTERY: UPHOLSTERY,
      BUY_AND_SELL: BUY_AND_SELL,
      token
    }).then((response) => {
      console.log(response.data);
      if (response.status === 200) {
        window.alert(response.data.message);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setTimeout(function () {
      window.location.reload();
    }, 2000);
  }
  return (
    <div className="MainPage_data">
      <div class="Container">
        <div>
          <div>
            <h2 style={{ padding: 5 }}>{Area}</h2>
            <br />
            <div class="row">
              <div class="col-2">
                <button className='btn btn-primary' onClick={() => { setAllColumns(!AllColumns) }} >All Columns</button>
              </div>
              <div class="col-2">
                <button
                  className="btn btn-secondary"
                  onClick={() => handleClick('flex')}
                  onDoubleClick={handleDoubleClick}
                >
                  {flex_inv ? 'Inventory History' : 'Flex'}
                </button>
              </div>
              <div class="col-1">
                <button
                  className="btn btn-primary"
                  onClick={() => handleClick('scrap')}
                  onDoubleClick={handleDoubleClick}
                >
                  {flex_inv ? 'Inventory History' : 'Scrap'}
                </button>
              </div>
              <div class="col-1">
                <button
                  className="btn btn-success"
                  onClick={() => handleClick('pivot')}
                  onDoubleClick={handleDoubleClick}
                >
                  {pivot ? 'Inventory History' : 'Pivot'}
                </button>
              </div>
              <div class="col-1">
                <button
                  className="btn btn-info"
                  onClick={() => handleClick('rigid')}
                  onDoubleClick={handleDoubleClick}
                >
                  {rigid_inv ? 'Inventory History' : 'Rigid'}
                </button>
              </div><div class="col-1">
                <button
                  className="btn btn-success"
                  onClick={() => handleClick('metal')}
                  onDoubleClick={handleDoubleClick}
                >
                  {metal_inv ? 'Inventory History' : 'Metal'}
                </button>
              </div><div class="col-1">
                <button
                  className="btn btn-secondary"
                  onClick={() => handleClick('slabfoam')}
                  onDoubleClick={handleDoubleClick}
                >
                  {slabfoam_inv ? 'Inventory History' : 'Slab Foam'}
                </button>
              </div>
              <div class="col-2">
                <button
                  className="btn btn-primary"
                  onClick={() => handleClick('wood')}
                  onDoubleClick={handleDoubleClick}
                >
                  {wood_inv ? 'Inventory History' : 'Woodshop'}
                </button>
              </div>
            </div >
            <div >
              {flex_inv ?
                (<Flex_Inventory partDataset={partDataset} onhandparts={postList} AllColumns={AllColumns} Area={Area} />) : rigid_inv ? (<Rigid_Inventory partDataset={partDataset} onhandparts={postList} AllColumns={AllColumns} Area={Area} />) : wood_inv ? (<Wood_Inventory partDataset={partDataset} onhandparts={postList} AllColumns={AllColumns} Area={Area} />)
                  : metal_inv ? (<Metal_Inventory partDataset={partDataset} onhandparts={postList} AllColumns={AllColumns} Area={Area} />)
                    : slabfoam_inv ? (<SlapFoam_Inventory partDataset={partDataset} onhandparts={postList} AllColumns={AllColumns} Area={Area} />)
                      : pivot ? (<InventoryReportTable AllColumns={AllColumns} Areas={Area} />)
                        : scrap_inv ? (<Scrap partDataset={partDataset} AllColumns={AllColumns} Area={Area} />)
                          : (<His_Inventory partDataset={partDataset} AllColumns={AllColumns} Areas={Area} />)
              }
            </div>
          </div>
        </div>
        <br></br>
        <br></br>
      </div>
    </div >
  )
}

export default Parts_Inventory;